import Modal from '@material-ui/core/Modal';
import MyButton from 'components/form/MyButton';
import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import RichTextEditor from 'react-rte';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import InfoOt from 'views/equipment/InfoOt';

const MyRichModal = ({ open, title, selectedOt, setOpen }) => {
  const [editorState, setEditorState] = useState(RichTextEditor.createValueFromString(selectedOt?.commentaire ? selectedOt?.commentaire : "", 'html'));

  useEffect(() => {
    if (open) {
      console.log("Ouvrir détail OT");
      setEditorState(RichTextEditor.createValueFromString(selectedOt?.commentaire ? selectedOt?.commentaire : "", 'html'));
    }
  }, [open]);

  const closeModal = (reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };

  return (
    <Modal open={open} onClose={(e, reason) => closeModal(reason)} style={{ display: 'flex' }} disableEscapeKeyDown={true}>
      <div className="my-modal">
        <div className="row-center">
          <div style={{ width: '50%', display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
            <h3 style={{ textTransform: 'uppercase', color: '#27313c', fontSize: isMobile ? '3.5vw' : '1vw' }}>{title}</h3>
          </div>
          <div style={{ width: '50%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <MyButton
              className="classic-button btn-default color-fond-vert"
              type="button"
              labelImportant="Fermer"
              href="#"
              iconLeft={{ icon: faTimes, type: 'fontAwesome' }}
              styleCss={{ fontSize: isMobile ? '2vw' : '0.8vw' }}
              onClick={closeModal}
            />
          </div>
        </div>

        <div className="row" style={{ margin: '0 1vw 1vw 1vw', flexWrap: 'nowrap' }}>
          <InfoOt ot={selectedOt} />
          <RichTextEditor readOnly={true} className="rich-text" value={editorState} rootStyle={{ height: isMobile ? '60vh' : '65vh', width: '45vw', marginLeft: '0.5vw' }} />
        </div>

      </div>
    </Modal>
  );
};

export default MyRichModal;